import React from "react";
import Icon from "assets/icons";
import { State } from "../../type";
import Button from "shared/components/button";
import { PurchaseTicketStep } from "../../util";
import NoteBox from "../../../../components/noteBox";
import { useCopies } from "../../../../../../shared/hooks/useCopies";
import { getFormattedCurrency } from "../../../../../../shared/utils";
import { useRegDetail } from "../../../../../../shared/context/regDetail";

export default function TicketPurchaseInfoText(props: {
  state: State;
  backClickHandler?: () => void;
  openAssignTicketToSelfHandler: () => void;
}) {
  const copies = useCopies();
  const { name, helpdeskEmail } = useRegDetail();

  const applicablePrice = React.useMemo(() => {
    if (props.state.participantData?.regPurchaseOrder) {
      return getFormattedCurrency(props.state.participantData?.regPurchaseOrder.amount);
    }
    if (props.state.couponCodeFormValues?.applicableRateCardDetailsByCouponCode) {
      return getFormattedCurrency(
        props.state.couponCodeFormValues?.applicableRateCardDetailsByCouponCode?.applicablePrice
      );
    }
    if (props.state.participantData?.registrationForm?.applicableRate) {
      return getFormattedCurrency(props.state.participantData?.registrationForm?.applicableRate?.applicablePrice);
    }
  }, [
    props.state.couponCodeFormValues?.applicableRateCardDetailsByCouponCode,
    props.state.participantData?.regPurchaseOrder,
    props.state.participantData?.registrationForm?.applicableRate
  ]);

  const appliedCouponCode = React.useMemo(() => {
    const lineObj = props.state.participantData?.regPurchaseOrder?.lines.find(item => !!item.couponCode);
    if (!lineObj) {
      return props.state.couponCodeFormValues?.applicableRateCardDetailsByCouponCode?.couponCode;
    }
    return lineObj?.couponCode;
  }, [props.state.participantData?.regPurchaseOrder?.lines, props.state.couponCodeFormValues]);

  return (
    <React.Fragment>
      <NoteBox isStylised>
        <p
          dangerouslySetInnerHTML={{
            __html: copies.get("get.ticket.info.text", {
              0: name,
              1: helpdeskEmail,
              2: helpdeskEmail
            })
          }}
        />
      </NoteBox>

      {props.state.couponCodeFlowApplicable && props.state.stepNo !== PurchaseTicketStep.SHOW_COUPON_CODE_FORM && (
        <div className="buyInventory_goBack">
          <Button label={copies.get("back")} icon={<Icon.ArrowBack />} onClick={props.backClickHandler} />
        </div>
      )}

      {applicablePrice && (
        <React.Fragment>
          <div className="buyTicket_info buyInventory_cardWrapper">
            <p
              className="buyTicket_info--rate"
              dangerouslySetInnerHTML={{
                __html: copies.get("ticket.rate.label", {
                  0: `<span class="buyTicket_info--rateValue">${applicablePrice}</span>`
                })
              }}
            />
            <span className="buyTicket_formDetails">
              <p className="buyTicket_formDetails--name">
                {props.state.participantData?.registrationForm?.title &&
                  props.state.participantData?.registrationForm?.title}
              </p>
              {appliedCouponCode && (
                <p
                  className="buyTicket_formDetails--coupon buyInventory_coupon"
                  dangerouslySetInnerHTML={{
                    __html: copies.get("applied.coupon.code", {
                      0: `<span class="buyInventory_coupon--value">${appliedCouponCode}</span>`
                    })
                  }}
                />
              )}
            </span>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
